import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from 'widgets/Button';
import Input from 'widgets/Input/Input';
import Textarea from 'widgets/Textarea/Textarea';

import {
  findErrorMessageForField,
} from '../../utils/createReview';

export default class CreateReviewAddDetails extends PureComponent {
  static propTypes = {
    sku: PropTypes.string.isRequired,
    rating: PropTypes.number,
    recommended: PropTypes.bool,
    newNickname: PropTypes.string,
    reviewTitle: PropTypes.string,
    reviewText: PropTypes.string,
    validationErrors: PropTypes.array,
    updateFields: PropTypes.func.isRequired,
    postReview: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    setNickname: PropTypes.func.isRequired,
  };

  static defaultProps = {
    validationErrors: [],
  };

  handleSubmit = () => {
    const { sku, rating, recommended, newNickname, reviewTitle, reviewText } = this.props;
    this.props.postReview(sku, {
      rating,
      recommended,
      termAgreed: true,
      customerNickname: newNickname && newNickname.trim(),
      reviewTitle,
      reviewText,
    }).then((isValid) => {
      if (!isValid) {
        return;
      }
      if (newNickname) {
        this.props.setNickname({ nickname: newNickname, status: 'PENDING' });
      }
      this.props.onSave();
    });
  };

  updateField = (name, value) => {
    this.props.updateFields({
      [name]: value,
      validationErrors: this.props.validationErrors.filter(error => error.field !== name),
    });
  }

  canSaveDetails = () =>
    this.props.reviewTitle
      && this.props.reviewText
      && this.props.validationErrors.length === 0;

  render() {
    const { validationErrors } = this.props;
    return (
      <>
        <div className="bop-review__titleGroup">
          <Input
            id="reviewTitle"
            name="reviewTitle"
            type="text"
            label="Review title"
            onChange={this.updateField}
            errorMessage={findErrorMessageForField(validationErrors, 'reviewTitle')}
            required
            maxLength="51"
            placeholder="Max. of 50 characters"
          />
        </div>
        <Textarea
          name="reviewText"
          id="reviewText"
          label="Review"
          required
          maxLength="4000"
          rows={2}
          onChange={this.updateField}
          className="bop-reviews__textarea"
          errorMessage={findErrorMessageForField(validationErrors, 'reviewText')}
          placeholder="Max. of 4,000 characters"
        />

        <div className="bop-review__buttonsWrapper">
          <Button
            className="bop-review__submit"
            disabled={!this.canSaveDetails()}
            onClick={this.handleSubmit}
          >
            Submit
          </Button>
        </div>
      </>
    );
  }
}
